import {
  FilterAltOffOutlined as FilterAltOffOutlinedIcon,
  FilterAltOutlined as FilterAltOutlinedIcon,
} from '@mui/icons-material'
import SearchIcon from '@mui/icons-material/Search'
import { Divider, IconButton, InputAdornment, Stack, TextField, debounce } from '@mui/material'
import { ECreditApplicationStatusFilters } from './creditEntriesFiltersDialog-hooks'

interface Props {
  searchTerm: string
  handleSearch: (value: string) => void
  onOpenFilterClicked: () => void
  creditApplicationStatusFilter: ECreditApplicationStatusFilters
  hasAFilter: boolean
  handleClearFilter: () => void
}

const TableFilters = ({
  searchTerm,
  handleSearch,
  onOpenFilterClicked,
  creditApplicationStatusFilter,
  hasAFilter,
  handleClearFilter,
}: Props) => {
  const debounceOnChange = debounce(handleSearch, 1000)
  const hiddenFilters = creditApplicationStatusFilter === ECreditApplicationStatusFilters.Draft
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <TextField
        defaultValue={searchTerm}
        onChange={(e) => debounceOnChange(e.target.value)}
        size="small"
        type="search"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
      {!hiddenFilters && (
        <Stack direction="row" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
          <IconButton size="large" onClick={onOpenFilterClicked} color={!hasAFilter ? 'primary' : 'warning'}>
            <FilterAltOutlinedIcon />
          </IconButton>
          <IconButton size="large" onClick={handleClearFilter} color="primary" disabled={!hasAFilter}>
            <FilterAltOffOutlinedIcon />
          </IconButton>
        </Stack>
      )}
    </Stack>
  )
}

export default TableFilters
